import { Point } from '@flatten-js/core';
import { getLengthCountsForArea } from '../helpers';

export class BreakerBoard {
  constructor(options) {
    ({
      points: this.points = [],
      id: this.id,
      indexInArea: this.indexInArea,
      area: this.area,
      rawArea: this.rawArea,
      plankCount: this.plankCount,
      areaCutoutPoints: this.areaCutoutPoints = [],
    } = options);

    if (options.vertices) {
      for (const vertex of options.vertices) {
        this.points.push(new Point(vertex.x, vertex.y));
      }
    }

    if (this.rawArea) {
      this.indexInArea = this.rawArea.data.descriptor.index;
      this.plankCount = this.rawArea.data.descriptor.plank_count || 0;
      this.areaCutoutPoints = this.rawArea.data.descriptor.area_cutout_points.map(item => new Point(item.x, item.y));
    }
  }

  get backendObject() {
    const data = dojo.clone(this.rawArea.data);
    data.deck_type = 'breakerboard';
    data.angle_rad = 0;
    data.points = this.points.map(point => {
      return { x: point.x, y: point.y };
    });

    data.descriptor = {};
    data.descriptor.id = this.id;
    data.descriptor.area_id = this.area.id;
    data.descriptor.index = this.indexInArea;
    data.descriptor.type = 'breaker_board';
    data.descriptor.plank_count = this.plankCount;
    data.descriptor.area_cutout_points = this.areaCutoutPoints.map(point => {
      return { x: point.x, y: point.y };
    });
    data.descriptor.group_id = this.area.groupId;
    return data;
  }

  set backendObjectFromParent(data) {
    this.rawArea = {
      data: data,
    };
    this.rawArea.data.active_edge = 0;
    this.rawArea.data.current_plan_index = 0;
    delete this.rawArea.data.points;
  }

  set rawArea(rawArea) {
    this._rawArea = rawArea;
  }

  get rawArea() {
    return this._rawArea;
  }

  get usedBoardLengthCounts() {
    return getLengthCountsForArea(this.rawArea.finalPlans.plans[0]);
  }

  get surfaceMM2() {
    // rawArea.stats might not exist before the recalculation is made (e. g. area splitting), use 0 then
    return this.rawArea.stats ? this.rawArea.stats.surface_mm2 : 0;
  }

  updateRawAreaData(key, value) {
    this.rawArea.data[key] = value;
  }
}
